import React from 'react'
import {Icon} from '@chakra-ui/react'

const NewIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M29.3701 20.3542C29.6044 20.7962 29.9663 21.158 30.4082 21.3923L36.7959 24.7791L30.4082 28.1667C30.0215 28.3718 29.6961 28.6743 29.4639 29.0427L29.3701 29.2048L25.9824 35.5925L22.5957 29.2048L22.502 29.0427C22.2698 28.6743 21.9442 28.3717 21.5576 28.1667L15.1689 24.7791L21.5576 21.3923C21.9996 21.158 22.3614 20.7962 22.5957 20.3542L25.9824 13.9656L29.3701 20.3542Z"
                stroke="currentColor"
                strokeWidth="3"
            />
            <path
                d="M12.7568 8.51196C12.9911 8.95382 13.3521 9.31574 13.7939 9.55005L17.6846 11.6125L13.7939 13.676C13.4074 13.8811 13.0827 14.1836 12.8506 14.552L12.7568 14.7131L10.6934 18.6038L8.63086 14.7131L8.53711 14.552C8.3049 14.1834 7.97957 13.8811 7.59277 13.676L3.70215 11.6125L7.59277 9.55005C8.0347 9.31575 8.39655 8.9539 8.63086 8.51196L10.6934 4.62134L12.7568 8.51196Z"
                stroke="currentColor"
                strokeWidth="3"
            />
        </Icon>
    )
}

export default NewIcon
